import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import { media } from 'styled-bootstrap-grid'

import StaticArrow from './StaticArrow'

const Wrapper = styled.div`
  background: ${props => props.theme.colors.grey.lightest};
  transform: translateY(-30px);
  height: 100%;

  ${media.xs`
    margin-bottom: ${props => props.noMobileMargin ? 0 : '55px'};
    height: auto;
  `}
`

const Image = styled.div`
  width: calc(100% + 20px);
  transform: translateX(30px) translateY(-30px);

  img {
    width: 100%;
    display: block;
  }
`

const Text = styled.p`
  padding: 30px 30px 0 30px;
  margin: 0;
  transform: translateY(-30px);
  font-size: 22px;
  line-height: 26px;
  color: ${props => props.theme.colors.oxford.light};
  font-weight: 400;

  ${media.xs`
    width: calc(100% - 60px);
    font-size: 16px;
    line-height: 20px;
    padding: 15px 15px 0 30px;
  `}
`

const Button = styled.div`
  width: 80px;
  height: 60px;
  background: ${props => props.theme.colors.pacific.base};
  position: absolute;
  bottom: 0;
  right: 50px;

  ${media.xs`
    top: 100%;
    left: 100%;
    transform: translateX(-105px);
  `}
`

export default class Featured extends Component {
  static propTypes = {
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }

  render() {
    const {
      image,
      link,
      text,
      noMobileMargin
    } = this.props

    return(
      <Link to={getRelativeUrl(link)}>
        <Wrapper noMobileMargin={noMobileMargin}>
          <Image>
            <Button>
              <StaticArrow />
            </Button>
            <img
              src={image}
              alt=""
            />
          </Image>
          <Text>{text}</Text>
        </Wrapper>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Hero/Featured.js